import { api } from './api';
import { DocumentRelationshipType } from '../types/documents';

class DocumentRelationshipTypeService {
  async getAll(includeInactive = false): Promise<DocumentRelationshipType[]> {
    const response = await api.get('/document-relationship-types', {
      params: { includeInactive },
    });
    return response.data;
  }

  async getById(id: string): Promise<DocumentRelationshipType> {
    const response = await api.get(`/document-relationship-types/${id}`);
    return response.data;
  }

  async create(data: Pick<DocumentRelationshipType, 'name' | 'description'>): Promise<DocumentRelationshipType> {
    const response = await api.post('/document-relationship-types', data);
    return response.data;
  }

  async update(id: string, data: { name: string; description?: string; isActive: boolean }): Promise<DocumentRelationshipType> {
    const response = await api.put(`/document-relationship-types/${id}`, {
      id,
      ...data,
    });
    return response.data;
  }

  async remove(id: string): Promise<void> {
    await api.delete(`/document-relationship-types/${id}`);
  }
}

export const documentRelationshipTypeService = new DocumentRelationshipTypeService();
